import type { ApplePayPaymentContact } from '../../typings/apple.types';
import type { DeliveryAddressInfo } from '../../typings/basket.types';
import { CountryCodeMapper } from '../country-code-mapper';

const retrieveApplePayDeliveryDetails = (shippingInfo: ApplePayPaymentContact): DeliveryAddressInfo => {
    const { givenName: firstName, familyName: lastName } = shippingInfo;

    const phone = shippingInfo.phoneNumber;
    const address1 = shippingInfo.addressLines[0] ? shippingInfo.addressLines[0] : '';
    const address2 = shippingInfo.addressLines[1] ? shippingInfo.addressLines[1] : undefined;
    const zipCode = shippingInfo.postalCode;
    const country = shippingInfo.countryCode;
    const stateAbbr = shippingInfo.administrativeArea;
    const city = shippingInfo.locality;
    const countryId = CountryCodeMapper.GetCountryId(country);

    return {
        firstName,
        lastName,
        phone,
        address1,
        address2,
        zipCode,
        city,
        countryId,
        stateAbbr,
        countryIso: country,
    };
};

export default retrieveApplePayDeliveryDetails;
